import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import { FC } from "react"
import "./KmzConversionNotice.less"
import arrowImg from "./assets/arrow.svg"

import CustomDivider from "@/components/custom-divider/CustomDivider"
import { SvgIcon } from "@/components/icon"
import InstructionItem, {
  InstructionItemProps,
} from "@/components/modal-dark/modal-dark-platform-content/kmz-conversion-notice/instruction-item/InstructionItem"
import instructionImg1 from "./assets/instructions-1.png"
import instructionImg2 from "./assets/instructions-2.png"
import instructionImg3 from "./assets/instructions-3.png"

const { Paragraph, Title } = WebsiteTypography

const instructionsContent: InstructionItemProps[] = [
  {
    title: "Open your KMZ file in Google Earth",
    imageSrc: instructionImg1,
    imageAlt: "Screenshot image illustrating the instruction",
    listItems: [
      "Simply double-click your .kmz file and it will automatically open in Google Earth Pro.",
      "(The contents will appear under the “Places” panel on the left side.)",
    ],
  },
  {
    title: "Right-click the imported layer",
    imageSrc: instructionImg2,
    imageAlt: "Screenshot image illustrating the instruction",
    listItems: ["In the Places panel, locate your imported KMZ folder or layer.", "Right-click it."],
  },
  {
    title: "Open your KMZ file in Google Earth",
    imageSrc: instructionImg3,
    imageAlt: "Screenshot image illustrating the instruction",
    listItems: [
      "From the right-click menu, choose Save Place As…",
      "In the save window, set Save as type: KML (*.kml) instead of KMZ",
      "Pick your folder location and click Save.",
    ],
  },
]

const KmzConversionNotice: FC = () => {
  const steps = [1, 2, 3]

  return (
    <Row justify={"center"}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Title level={4} centered style={{ paddingBottom: 16 }} color={"black"} weight={"w700"}>
          {"Converting a KMZ to KML \n" + "in Google Earth"}
        </Title>

        <Paragraph color={"black"} centered style={{ paddingBottom: 16 }}>
          {"Our application supports KML files only. Please convert your KMZ file to KML before uploading."}
        </Paragraph>
      </Col>

      <Col span={24} style={{ paddingBottom: 16 }}>
        <Row wrap={false} justify={"center"}>
          <div className={"steps-wrapper"}>
            {steps.map((step, index) => (
              <div className={"step-illustration-wrapper"} key={step}>
                <div className={"circle-step"}>
                  <Paragraph color={"black"}>{step}</Paragraph>
                </div>

                {index !== steps.length - 1 && (
                  <div className={"arrow-line"}>
                    <div className={"arrow-wrapper"}>
                      <img src={arrowImg} alt={""} />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </Row>
      </Col>

      <Row wrap={false}>
        <div className={"instruction-items-wrapper"}>
          {instructionsContent.map((item, index) => (
            <InstructionItem key={index} title={item.title} imageSrc={item.imageSrc} listItems={item.listItems} />
          ))}
        </div>
      </Row>

      <Col span={22}>
        <CustomDivider marginTop={0} marginBottom={8} color={"green"}>
          <SvgIcon type={"circled-tick"} color={"green"} />
        </CustomDivider>
      </Col>

      <Paragraph color={"green"} centered>
        {"You now have a KML file that can be uploaded onto the system."}
      </Paragraph>
    </Row>
  )
}

export default KmzConversionNotice
